document.addEventListener("DOMContentLoaded", function () {
  const headerContainer = document.querySelector(".header__container");
  if (!headerContainer) return;

  const replayWorldWrapper = document.createElement("div");
  replayWorldWrapper.className = "replay-world-flyout";
  replayWorldWrapper.innerHTML = `
    <div class="replay-world-button">Replay World</div>
    <div class="replay-world-dropdown">
      <!--<a href="#" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/Nuovo_progetto_28_.jpg" alt="Collab">
        <span>COLLAB</span>
      </a>-->
      <a href="/collections/9zero1" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/Nuovo_progetto_35_.jpg" alt="9ZERO1">
        <span>9ZERO1</span>
      </a>
      <!--<a href="#" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/Replay_World_Image_-_390x400.jpg" alt="Fragrances">
        <span>FRAGRANCES</span>
      </a>
      <a href="#" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/NEW_CONTENT_UPDATE/390x400-2.jpg" alt="Sustainability">
        <span>SUSTAINABILITY</span>
      </a>-->
      <a href="/pages/dna" class="replay-tile">
        <img src="https://replayjeans.kleecks-cdn.com/it/media/wysiwyg/Replay_World/390X400-2.jpg" alt="DNA">
        <span>DNA</span>
      </a>
    </div>
  `;

  // Vložit vlevo do header containeru
  headerContainer.insertBefore(replayWorldWrapper, headerContainer.firstChild);
});
